// Needed to support async await
import 'regenerator-runtime/runtime'
import App from './App'
import render from 'commons/js/util/render'
import { init } from 'commons/js/util/reporter'

init()

const element = document.querySelector('.js-rental-car-c2c')

render({App, element, props: {}})
